import styled from 'styled-components';

const ListItemText = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
`;

export { ListItemText };
